import { environment } from "../../environments/environment";

export const AppConstants={
    MIME_TYPES : {
        pdf  : 'application/pdf',
        xls  : 'application/vnd.ms-excel',
        xlsx : 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      },
    WHOAMI_URL:environment.USER_SERVICE_URL+"/whoami",
    GET_ALLUSERS_INFO:environment.USER_SERVICE_URL+"/all",
    GET_USERS_BY_STORE:environment.USER_SERVICE_URL+"/getUsersByStore",
    GET_ALLUSERS_BY_STORE:environment.USER_SERVICE_URL+"/getSignedUsersByStore",
    UPDATE_ESA:environment.USER_SERVICE_URL+"/updateESignAttestation",
    SAVE_USERS_INFO:environment.USER_SERVICE_URL+"/addUser",
    SAVE_USERS_PROFILE:environment.USER_SERVICE_URL+"/updateUserProfile",
    GET_LOGGED_USER_INFO:environment.USER_SERVICE_URL+"/getLoginUserByUpn",
    GET_USER_INFO:environment.USER_SERVICE_URL+"/getUserByUpn",
    GET_USER_SEQ:environment.USER_SERVICE_URL+"/getBySequenceNumber",
    GET_DASHBOARD_SUMMARY:environment.DASHBOARD_SERVICE_URL+'/getDashBoardSummary',
    GET_DASHBOARD_PAGE_SUMMARY:environment.DASHBOARD_SERVICE_URL+'/getPageDashBoardSummary',
    GET_PURCHASE_ORDER_DATA:environment.PURCHASE_ORDER_SERVICE_URL+'/getOrderSummaryReport',
    GET_DC_PURCHASE_ORDER_DATA:environment.PURCHASE_ORDER_SERVICE_URL+'/getDCOrderSummaryReport',
    GET_PURCHASE_ORDER_DETAILS_DATA:environment.PURCHASE_ORDER_SERVICE_URL+'/getPODetails',

    GET_NCTM_USER_ACCESS:environment.NCTM_GET_USER_ACCESS_URL+"/getUserAccessByUPN",

    APPPORVE_OC_PURCHASE_ORDER_DATA:environment.PURCHASE_ORDER_SERVICE_URL+'/approvedOC',
    APPROVE_RC_PURCHASE_ORDER_DATA:environment.PURCHASE_ORDER_SERVICE_URL+'/approvedRC',
    UPDATE_PURCHASE_ORDER_DATA:environment.PURCHASE_ORDER_SERVICE_URL+'/updatePODetails',
    REMOVE_REPORT_PURCHASE_ORDER_DATA:environment.PURCHASE_ORDER_SERVICE_URL+'/removePOReportedDetails',
    GET_PROVINCES:environment.PROVINCE_SERVICE_URL+'/getProvinces',
    ADVANCE_SEACH:environment.PURCHASE_ORDER_SERVICE_URL+'/advancedSearch',

    ///STORES

    GET_STORES:environment.STORE_MAINTAINENCE_SERVICE_URL+'/all',
    GET_STORE_BY_SEQ:environment.STORE_MAINTAINENCE_SERVICE_URL,
    UPDATE_STORE_EMAIL:environment.STORE_MAINTAINENCE_SERVICE_URL+"/addStoresEmails",
    UPDATE_STORE:environment.STORE_MAINTAINENCE_SERVICE_URL,
    UPDATE_LOGOUT:environment.USER_SERVICE_URL+"/updateLogoutStatus",

    
    GET_DC:environment.DC_MAINTAINENCE_SERVICE_URL+'/all',
    GET_DC_BY_SEQ:environment.DC_MAINTAINENCE_SERVICE_URL,
    UPDATE_DC_EMAIL:environment.DC_MAINTAINENCE_SERVICE_URL+"/addDCEmails",
    UPDATE_DC:environment.DC_MAINTAINENCE_SERVICE_URL,


    //Reprots

    GET_SINGED_ORDERS:environment.REPORTS_SERVICE_HOST+"/getSignedResultsReport",
    GET_SINGED_ORDERS_REPORT:environment.REPORTS_SERVICE_HOST+"/getSignedReport",
    GET_UNSINGED_PACKAGES_REPORT:environment.REPORTS_SERVICE_HOST+"/getUnsignedPackagesReport",
    GET_MAR_REPORT:environment.REPORTS_SERVICE_HOST+"/getMARReport",
    GET_MSR_REPORT:environment.REPORTS_SERVICE_HOST+"/getMissingSignatureReport",
    GET_EXCEPTION_REPORT:environment.REPORTS_SERVICE_HOST+"/getExceptionReport",
    GET_EXCEPTION_RESULTS:environment.REPORTS_SERVICE_HOST+"/getExceptionResultsReport",
    GET_ESA_RESULTS_REPORT:environment.REPORTS_SERVICE_HOST+"/getElectronicAttestSignReport",
    
    
    ///Route Constants

    DASHBOARD_ROUTE:"/dcn-esign/dashboard"
}